// i18n — Wave 7 Day 3 minimal shim.
//
// Per-page typed string dictionaries indexed by Locale. No i18next /
// react-intl dependency — PEXIFY scale (~6 pages worth of UI text to
// translate) doesn't justify the runtime. Pattern:
//
//   const T = { en: { title: 'Foo' }, tr: { title: 'Bar' } }
//   const t = useT(T)
//   <h1>{t.title}</h1>
//
// Lazy-imported dictionaries keep bundle splitting clean.

import { useLocaleStore, type Locale } from '../store/locale'

export type LocalizedDict<T> = Record<Locale, T>

export function useT<T>(dict: LocalizedDict<T>): T {
  const locale = useLocaleStore((s) => s.locale)
  return dict[locale]
}

export function pickT<T>(dict: LocalizedDict<T>, locale: Locale): T {
  return dict[locale]
}
